const NUDGE_KEY = 'hangrily_nudge_settings';
const LAST_NUDGE_KEY = 'hangrily_last_nudge';

const MEAL_NUDGES = [
  { id: 'lunch', hour: 11, minute: 30, messages: [
    "Lunchtime! Can't decide where to eat? Swipe it out.",
    "Your stomach is calling. Time to find lunch!",
    "Lunch break = decision time. Open Hangrily!",
  ]},
  { id: 'dinner', hour: 17, minute: 30, messages: [
    "Dinner time! Stop scrolling, start swiping.",
    "The 'where should we eat?' argument starts now. Or you could just use Hangrily.",
    "Hungry yet? Let's find dinner in 2 minutes.",
  ]},
];

export function getNudgeSettings() {
  try {
    const saved = localStorage.getItem(NUDGE_KEY);
    return saved ? JSON.parse(saved) : { enabled: false, lunch: true, dinner: true };
  } catch {
    return { enabled: false, lunch: true, dinner: true };
  }
}

export function saveNudgeSettings(settings) {
  localStorage.setItem(NUDGE_KEY, JSON.stringify(settings));
  if (settings.enabled) {
    scheduleNudges();
  } else {
    clearNudgeTimers();
  }
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  const result = await Notification.requestPermission();
  return result;
}

export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

function getRandomMessage(messages) {
  return messages[Math.floor(Math.random() * messages.length)];
}

function getLastNudge(mealId) {
  try {
    const data = JSON.parse(localStorage.getItem(LAST_NUDGE_KEY) || '{}');
    return data[mealId] || null;
  } catch { return null; }
}

function setLastNudge(mealId) {
  try {
    const data = JSON.parse(localStorage.getItem(LAST_NUDGE_KEY) || '{}');
    data[mealId] = new Date().toDateString();
    localStorage.setItem(LAST_NUDGE_KEY, JSON.stringify(data));
  } catch { /* ignore */ }
}

function sendNudge(meal) {
  const today = new Date().toDateString();
  if (getLastNudge(meal.id) === today) return;

  const settings = getNudgeSettings();
  if (!settings.enabled || !settings[meal.id]) return;
  if (Notification.permission !== 'granted') return;

  const message = getRandomMessage(meal.messages);
  const notification = new Notification('Hangrily', {
    body: message,
    icon: '/logo192.png',
    badge: '/logo192.png',
    tag: `hangrily-${meal.id}`,
    renotify: false,
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
  };

  setLastNudge(meal.id);
}

let nudgeIntervalId = null;

export function scheduleNudges() {
  clearNudgeTimers();

  const settings = getNudgeSettings();
  if (!settings.enabled) return;
  if (Notification.permission !== 'granted') return;

  // Check every minute if it's time for a nudge
  nudgeIntervalId = setInterval(() => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    MEAL_NUDGES.forEach(meal => {
      if (currentHour === meal.hour && currentMinute === meal.minute) {
        sendNudge(meal);
      }
    });
  }, 60000);

  // Also check immediately in case we're right on time
  const now = new Date();
  MEAL_NUDGES.forEach(meal => {
    if (now.getHours() === meal.hour && now.getMinutes() === meal.minute) {
      sendNudge(meal);
    }
  });
}

export function clearNudgeTimers() {
  if (nudgeIntervalId) {
    clearInterval(nudgeIntervalId);
    nudgeIntervalId = null;
  }
}

// Initialize on import if settings are enabled
export function initNudges() {
  const settings = getNudgeSettings();
  if (settings.enabled && Notification.permission === 'granted') {
    scheduleNudges();
  }
}
